var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2454_141366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.25 13L11.9286 10M9.07143 10L5.75002 13M5.5 7.5L9.58246 10.3577C9.91304 10.5891 10.0783 10.7048 10.2581 10.7497C10.4169 10.7892 10.5831 10.7892 10.7419 10.7497C10.9217 10.7048 11.087 10.5891 11.4175 10.3577L15.5 7.5M7.9 14H13.1C13.9401 14 14.3601 14 14.681 13.8365C14.9632 13.6927 15.1927 13.4632 15.3365 13.181C15.5 12.8601 15.5 12.4401 15.5 11.6V8.4C15.5 7.55992 15.5 7.13988 15.3365 6.81901C15.1927 6.53677 14.9632 6.3073 14.681 6.16349C14.3601 6 13.9401 6 13.1 6H7.9C7.05992 6 6.63988 6 6.31901 6.16349C6.03677 6.3073 5.8073 6.53677 5.66349 6.81901C5.5 7.13988 5.5 7.55992 5.5 8.4V11.6C5.5 12.4401 5.5 12.8601 5.66349 13.181C5.8073 13.4632 6.03677 13.6927 6.31901 13.8365C6.63988 14 7.05992 14 7.9 14Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2454_141366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4.5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.39509c60fd238a088fb1bb6409370d7b.svg";
export { ForwardRef as ReactComponent };